import { requireDashboardOrigin } from "@playbrain/auth/server/dashboardOriginGuard"
import { serverRouteConfig } from "@server/server-route-config"
import { dashboardApiErrorMessage } from "@site-server/dashboard-api-errors"
import { createFileRoute } from "@tanstack/react-router"
import * as z from "zod"

/**
 * Starts the Google handshake. Returns the URL rather than redirecting, so the
 * caller performs a top-level navigation -- the PKCE verifier cookie has to be
 * set on this response before the browser leaves.
 */
const startSchema = z.object({
  returnTo: z.string().max(512).optional(),
})

export const Route = createFileRoute("/api/dashboard/auth/sso")(
  serverRouteConfig({
    server: {
      handlers: {
        POST: async ({ request }) => {
          const originError = requireDashboardOrigin(request)
          if (originError) return originError

          try {
            const input = startSchema.parse(await request.json())
            const { startDashboardSso } = await import("@api/features/dashboard-auth/dashboardSsoApi")
            /** The SDK wrote its PKCE verifier cookie onto this response already. */
            const result = await startDashboardSso({ returnTo: input.returnTo, request })
            return Response.json({ url: result.url })
          } catch (error) {
            return Response.json(
              { error: dashboardApiErrorMessage(error, "Could not start Google sign-in.") },
              { status: 400 }
            )
          }
        },
      },
    },
  })
)
